export const isLoyaltyProgramTutorialFlagOn = (
  loyaltyProgramTutorialFF: boolean | 'off' | 'after_first_session' | 'after_1_sc_bet',
) => {
  return [true, 'after_first_session', 'after_1_sc_bet'].includes(loyaltyProgramTutorialFF);
};
